import React from 'react';

export default function BellNecklaceSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Thin chain (tan/gold curve around neck) */}
      <path d="M4 16 C8 22 14 25 20 25 C26 25 32 22 36 16" stroke="#D4A24A" strokeWidth="1.2" fill="none" />
      <path d="M4 16 C8 22 14 25 20 25 C26 25 32 22 36 16" stroke="#FFE082" strokeWidth="0.4" fill="none" opacity="0.6" />
      {/* Chain link dots */}
      <circle cx="8" cy="19" r="0.5" fill="#B8860B" />
      <circle cx="13" cy="22" r="0.5" fill="#B8860B" />
      <circle cx="27" cy="22" r="0.5" fill="#B8860B" />
      <circle cx="32" cy="19" r="0.5" fill="#B8860B" />
      {/* Bell loop */}
      <rect x="19" y="23" width="2" height="2" rx="0.5" fill="#B8860B" />
      {/* Bell body */}
      <path d="M14 26 C14 32 17 35 20 35 C23 35 26 32 26 26 L24 25 L16 25 Z" fill="#FFD54F" />
      {/* Bell rim */}
      <ellipse cx="20" cy="34" rx="6" ry="1.2" fill="#FFB300" />
      {/* Bell highlight */}
      <path d="M16 27 C16 30 17 32 18 33" stroke="#FFF59D" strokeWidth="1.2" strokeLinecap="round" fill="none" opacity="0.7" />
      {/* Bell clapper */}
      <circle cx="20" cy="33.5" r="1.2" fill="#8B6914" />
      {/* Bell shading */}
      <path d="M23 27 C23 30 22 33 21 34" stroke="#B8860B" strokeWidth="0.8" strokeLinecap="round" fill="none" opacity="0.5" />
    </svg>
  );
}
